import OrganizationsService from "@/services/OrganizationsService";
import { replaceItemInList, removeItemFromList, getListItems, getListPagination } from "@/utils/listHelpers";
import { getApiErrorMessage, notifyStoreError } from "@/utils/storeHelpers";
export default {
    namespaced: true,
    state: {
        organizationsData: [],
        selectedOrganization: null,
        status: null,
    },
    getters: {
        getOrganizationsData: (state) => getListItems(state.organizationsData),
        getOrganizationsPagination: (state) => getListPagination(state.organizationsData),
        getSelectedOrganization: (state) => state.selectedOrganization,
        getSelectedOrganizationId: (state) => state.selectedOrganization?.id ?? null,
        getStatus: (state) => state.status,
    },
    mutations: {
        setOrganizationsData(state, data) {
            state.organizationsData = data;
        },
        setSelectedOrganization(state, organization) {
            state.selectedOrganization = organization;
        },
        setStatus(state, status) {
            state.status = status;
        },
        createOrganizationInList(state, organization) {
            if (!organization)
                return;
            if (Array.isArray(state.organizationsData)) {
                state.organizationsData.push(organization);
            }
            else if (state.organizationsData?.data && Array.isArray(state.organizationsData.data)) {
                state.organizationsData.data.push(organization);
            }
        },
    },
    actions: {
        async getOrganizations({ commit, dispatch }, payload) {
            try {
                const response = await OrganizationsService.getOrganizations(payload.data, payload.userToken);
                commit('setOrganizationsData', response);
            }
            catch (error) {
                console.error('Erro ao buscar organizações', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao buscar organizações'));
            }
            finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true });
                }
            }
        },
        async createOrganization({ commit, dispatch }, payload) {
            try {
                const response = await OrganizationsService.createOrganization(payload.organization, payload.userToken);
                commit('createOrganizationInList', response.data);
                dispatch('toastfy/activeSuccesNotification', { text: 'Organização adicionada com sucesso' }, { root: true });
                return response;
            }
            catch (error) {
                notifyStoreError(dispatch, 'Erro ao adicionar organização', error);
                throw error;
            }
        },
        async updateOrganization({ commit, state, dispatch }, payload) {
            try {
                const response = await OrganizationsService.updateOrganization(payload.organization, payload.userToken);
                const updatedOrganization = response.data;
                dispatch('toastfy/activeSuccesNotification', { text: 'Organização atualizada com sucesso' }, { root: true });
                commit('setOrganizationsData', replaceItemInList(state.organizationsData, updatedOrganization));
                if (state.selectedOrganization?.id === updatedOrganization.id) {
                    commit('setSelectedOrganization', updatedOrganization);
                }
                return response;
            }
            catch (error) {
                notifyStoreError(dispatch, 'Erro ao atualizar organização', error);
                throw error;
            }
        },
        async deleteOrganization({ commit, state, dispatch }, payload) {
            try {
                await OrganizationsService.deleteOrganization(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Organização deletada com sucesso' }, { root: true });
                const organizationId = payload.data;
                commit('setOrganizationsData', removeItemFromList(state.organizationsData, organizationId));
                if (state.selectedOrganization?.id === organizationId) {
                    commit('setSelectedOrganization', null);
                }
            }
            catch (error) {
                notifyStoreError(dispatch, 'Erro ao deletar organização', error);
            }
        },
        setSelectedOrganization({ commit }, organization) {
            commit('setSelectedOrganization', organization);
        },
    }
};
